
import { defineComponent } from 'vue';
import ClickOutside from '@/util/directives/ClickOutside';

export default defineComponent({
    emits: ['update:value'],
    directives: { ClickOutside },
    props: {
        label: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: [],
        },
        value: {
            required: true,
        },
        itemText: {
            type: String,
            required: true,
        },
        itemValue: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            expandDropdown: false,
        };
    },
    methods: {
        onSelectClicked() {
            this.expandDropdown = !this.expandDropdown;
        },
        onItemClicked(item: any) {
            this.$emit('update:value', item);
            this.expandDropdown = false;
        },
    },
});
